import React, { useState } from 'react';
import { Eye, EyeOff, Stethoscope, Lock, Mail, Zap } from 'lucide-react';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin();
  };

  return (
    <div className="login-page">
      <div className="login-bg-pattern" />

      <div className="login-container">
        <div className="login-left">
          <div className="login-left-content">
            <Stethoscope size={48} strokeWidth={1.5} />
            <h2>RESPIDOM</h2>
            <p className="login-subtitle">Assistance Respiratoire & Matériel Médical</p>
            <div className="login-separator" />
            <p className="login-description">
              Espace dédié aux établissements de santé pour commander
              du matériel d'assistance respiratoire en location et gérer
              vos équipements en toute simplicité.
            </p>
            <div className="login-features">
              <div className="login-feature">
                <div className="login-feature-dot" />
                <span>Commande de matériel à la location</span>
              </div>
              <div className="login-feature">
                <div className="login-feature-dot" />
                <span>Bons de commande générés automatiquement</span>
              </div>
              <div className="login-feature">
                <div className="login-feature-dot" />
                <span>Arrêt de location en un clic</span>
              </div>
            </div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-form-container">
            <div className="login-form-header">
              <h1>Connexion</h1>
              <p>Accédez à votre espace établissement</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Adresse e-mail professionnelle</label>
                <div className="input-wrapper">
                  <Mail size={18} className="input-icon" />
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="prenom.nom@etablissement.fr"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Mot de passe</label>
                <div className="input-wrapper">
                  <Lock size={18} className="input-icon" />
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>

              <div className="form-options">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span className="checkmark" />
                  Se souvenir de moi
                </label>
                <button type="button" className="link-button">Mot de passe oublié ?</button>
              </div>

              <button type="submit" className="login-submit">
                Se connecter
              </button>

              <div className="login-divider">
                <span>ou</span>
              </div>

              <button type="button" className="login-demo" onClick={onLogin}>
                <Zap size={18} />
                Accès direct démo
              </button>
            </form>

            <div className="login-footer">
              <p>Pas encore de compte ? Contactez votre référent RESPIDOM</p>
              <p className="login-phone">01 45 XX XX XX</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
